export default __webpack_public_path__ + "static/media/teamsIconHC.8f6b37b9.svg";